import i18n from '@/i18n'

const stringToNumber = (value) => {
    if (typeof value === 'string') {
        return parseFloat(value)
    }

    return value
}

const decimalFormat = (number, decimals = 2) => {
    if (number) {
        number = stringToNumber(number)

        return parseFloat((Math.round(number * 100) / 100).toFixed(decimals))
    }
    return number
}

const formatTheNumberByLocation = (number, maximumFractionDigits = 3) => {
    number = stringToNumber(number)
    if (typeof number != 'number' || isNaN(number)) {
        return false
    }

    return new Intl.NumberFormat(i18n.locale, { maximumFractionDigits }).format(number)
}

const formatNumber = (number, decimals = 10) => {
    return formatTheNumberByLocation(decimalFormat(number, decimals), decimals)
}

const formatPercentage = (number) => {
    return formatTheNumberByLocation(number, 2)
}

const getProgressColor = (value) => {
    let variant
    if (value <= 30) {
        variant = {
            name: 'danger',
            hex: '#f86c6b',
        }
    } else if (value > 30 && value <= 70) {
        variant = {
            name: 'warning',
            hex: '#ffc107',
        }
    } else if (value > 70) {
        variant = {
            name: 'success',
            hex: '#4dbd74',
        }
    }
    return variant
}

const isObjectEmpty = (object) => Object.keys(object).length === 0 && object.constructor === Object

const forceFileDownload = (response, filename) => {
    let a = document.createElement('a')
    a.download = filename
    a.target = '_blank'
    a.style = 'display: none'
    document.body.appendChild(a)
    a.href = URL.createObjectURL(new Blob([response.data]))
    a.click()
}

const sumByKey = (object, key) => {
    return object.reduce((acc, info) => {
        let value = key in info ? info[key] : 0
        return acc + value
    }, 0)
}

export const onlyNumbers = (value) => {
    const pattern = /[0-9]+/g
    return (value.match(pattern) || []).join('')
}

export {
    decimalFormat,
    formatTheNumberByLocation,
    getProgressColor,
    isObjectEmpty,
    formatNumber,
    formatPercentage,
    forceFileDownload,
    sumByKey,
}
